import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export const constantRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/index/index'),
        meta: { title: '首页', icon: 'home' }
      },
      {
        path: 'time',
        name: 'time',
        component: () => import('@/views/time/time'),
        meta: { title: '按次扣费', icon: 'time' }
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: () => import('@/views/recharge/recharge'),
        meta: { title: '打折用户', icon: 'recharge' }
      },
      {
        path: 'log',
        name: 'log',
        component: () => import('@/views/log/log'),
        meta: { title: '用户记录', icon: 'log' }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login'),
    meta: { title: '登录', icon: 'login' },
    // 设置登录页面的布局组件，该布局组件不包含菜单栏
    meta: { layout: 'noMenu' }
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRouterMap
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next();
  const tokenStr = window.localStorage.getItem('token')
  if (!tokenStr) return next('/login')
  next()
})

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js